import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";

const InputMultiSelect = ({
  options,
  selectedValues,
  onChange,
  placeholder
}) => (
  <Select
    mode={"multiple"}
    size={"large"}
    style={{ width: "100%", marginTop: "8px" }}
    placeholder={placeholder}
    showSearch={false}
    //optionFilterProp={"text"}
    value={selectedValues}
    onChange={onChange}
    // filterOption={(input, option) =>
    //   option.props.children.toLowerCase().indexOf(input.toLowerCase()) ===
    //   0
    // }
  >
    {options.map(o => (
      <Select.Option
        key={o.value}
        value={o.value}
        //    disabled={disabledValues && disabledValues.indexOf(o.value) >= 0}
      >
        {o.text ? o.text : o.value}
      </Select.Option>
    ))}
  </Select>
);

InputMultiSelect.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array.isRequired,
  selectedValues: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default InputMultiSelect;



// WEBPACK FOOTER //
// ./src/views/components/input_multiselect/InputMultiSelect.jsx